import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { Helmet } from 'react-helmet';
import { AdminPlayerSeason, Loading } from 'Components';
import { GET_ADMIN_PLAYER_SEASON_DATA } from 'services/queries';
import { CURRENT_SEASON, sortPlayersByName } from 'utils';

const AdminPlayerSeasonMigration = () => {
  const [currentSeasonId, setCurrentSeasonId] = useState(CURRENT_SEASON);
  const [nextSeasonId, setNextSeasonId] = useState(CURRENT_SEASON + 1);

  const {
    loading,
    error,
    data,
    refetch: refetchPlayerData,
  } = useQuery(GET_ADMIN_PLAYER_SEASON_DATA, {
    variables: { currentSeason: currentSeasonId, nextSeason: nextSeasonId },
  });

  if (loading) return <Loading />;
  if (error) return `error: ${error.message}`;

  const { players, teams } = data;

  const handleSelectCurrentSeason = (e) => {
    setCurrentSeasonId(e.target.value);
  };
  const handleSelectNextSeason = (e) => {
    setNextSeasonId(e.target.value);
  };

  return (
    <div>
      <Helmet>
        <title>Rosters | Admin | GBH Players Club</title>
      </Helmet>
      {players.length > 0 && (
        <AdminPlayerSeason
          currentSeasonId={currentSeasonId}
          nextSeasonId={nextSeasonId}
          handleSelectCurrentSeason={handleSelectCurrentSeason}
          handleSelectNextSeason={handleSelectNextSeason}
          players={[...players].sort(sortPlayersByName)}
          refetchPlayerData={refetchPlayerData}
          teams={teams}
        />
      )}
    </div>
  );
};

export default AdminPlayerSeasonMigration;
